/** The shortest a console password may be; the server holds the same. */
export const PASSWORD_MIN_LENGTH = 12

/** Why the two new-password fields cannot be sent yet, or null. */
export const newPasswordProblem = (
  password: string,
  repeated: string,
): string | null => {
  if (Array.from(password).length < PASSWORD_MIN_LENGTH) {
    return `Use at least ${String(PASSWORD_MIN_LENGTH)} characters`
  }
  if (password !== repeated) {
    return 'The two passwords are not the same'
  }
  return null
}
